<template>
    <button class="sc-user-input--send-icon-wrapper is-clickable" @click.prevent="onClick">
        <e-icon icon="message" size="is-medium" />
    </button>
</template>

<script>
export default {
    props: {
        onClick: {
            type: Function,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.sc-user-input--send-icon-wrapper {
    background: none;
    border: none;
    padding: $size-10;
    margin: 0;
    outline: none;

    .icon {
        color: $text;
    }
}

.sc-user-input--send-icon-wrapper:focus {
    outline: none;
}
</style>
